{
  "domain": "dev-auth.ocadohub.com",
  "clientId": "wcVCdUI1sjjzdo1MzqMElRmXXGDZpjj2",
  "authorizationParams": {
    "audience": "https://commercial.ocadohub.com/v1",
    "scope": "openid profile email offline_access"
  },
  "apiUri": "https://tst-commercial.ocadohub.com",
  "errorPath": "/error"
}
